import 'fancybox-core';
import 'fancybox-media';

const $sharepopup = $('.shareButton');
if ($sharepopup.length > 0) {
  // project centre share popup
  $('.projectTopBanner .shareButton').fancybox({
    beforeShow() {
      $('.fancybox-skin').css('backgroundColor', 'transparent');
    },
    maxWidth: 800,
    maxHeight: 800,
    width: '50%',
    height: '50%',
    closeBtn: false,
    openEffect: 'none',
    closeEffect: 'none',
    margin: 0,
    padding: 0,
    afterShow() {
      $('.fancybox-inner').css('overflow', 'inherit');
    },
  });
}
